import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";
// import { SocketContext } from "../../context/Socket/SocketContext";
import n8n from "../../assets/n8n.png";
import dialogflow from "../../assets/dialogflow.png";
import webhooks from "../../assets/webhook.png";
import typebot from "../../assets/typebot.jpg";
import flowbuilder from "../../assets/flowbuilders.png";

import { makeStyles } from "@material-ui/core/styles";

import {
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@material-ui/core";

import {
  AccountBalanceWalletOutlined,
  DeleteOutline,
  DnsOutlined,
  Edit,
  ExtensionOutlined,
  HotelOutlined,
  MemoryOutlined,
  WifiOutlined,
} from "@material-ui/icons";

import SearchIcon from "@material-ui/icons/Search";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import IntegrationModal from "../../components/QueueIntegrationModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import EmptyState from "../../components/EmptyState";
import { StatusBadge } from "../../components/ui";
import { usePanelStyles } from "../../components/QueueIntegrationModal/panelKit";
import { getTokens } from "../../styles/tokens";

// Tipos com logotipo próprio; os demais ganham ícone em quadrado de tinta da marca.
const TYPE_LOGOS = { dialogflow, n8n, webhook: webhooks, typebot, flowbuilder };
const TYPE_ICONS = {
  SGP: DnsOutlined,
  IXC: DnsOutlined,
  ASAAS: AccountBalanceWalletOutlined,
  ISP_IA: MemoryOutlined,
  HOTSPOT: WifiOutlined,
  HOSPEDAGEM_CONECTOR: HotelOutlined,
  HOSPEDAGEM_IA: HotelOutlined,
};
const TYPE_NAMES = {
  dialogflow: "DialogFlow",
  n8n: "N8N",
  webhook: "WebHooks",
  typebot: "Typebot",
  flowbuilder: "Flowbuilder",
};
const typeLabel = (type) =>
  TYPE_ICONS[type]
    ? i18n.t(`queueIntegrationModal.types.${type}`)
    : TYPE_NAMES[type] || type || "—";

const reducer = (state, action) => {
  if (action.type === "LOAD_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const newIntegrations = [];

    queueIntegration.forEach((integration) => {
      const integrationIndex = state.findIndex((u) => u.id === integration.id);
      if (integrationIndex !== -1) {
        state[integrationIndex] = integration;
      } else {
        newIntegrations.push(integration);
      }
    });

    return [...state, ...newIntegrations];
  }

  if (action.type === "UPDATE_INTEGRATIONS") {
    const queueIntegration = action.payload;
    const integrationIndex = state.findIndex(
      (u) => u.id === queueIntegration.id
    );

    if (integrationIndex !== -1) {
      state[integrationIndex] = queueIntegration;
      return [...state];
    } else {
      return [queueIntegration, ...state];
    }
  }

  if (action.type === "DELETE_INTEGRATION") {
    const integrationId = action.payload;

    const integrationIndex = state.findIndex((u) => u.id === integrationId);
    if (integrationIndex !== -1) {
      state.splice(integrationIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    typeCell: { display: "flex", alignItems: "center", gap: 12, minWidth: 0 },
    typeMark: {
      flex: "none",
      width: 36,
      height: 36,
      display: "grid",
      placeItems: "center",
      borderRadius: t.radius.sm,
      backgroundColor: t.tint.soft,
      color: t.brand,
      "& .MuiSvgIcon-root": { fontSize: 20 },
    },
    // logotipos são imagens de fundo claro: a plaquinha fica branca nos dois temas
    typeLogo: {
      backgroundColor: "#ffffff",
      border: `1px solid ${t.line}`,
      overflow: "hidden",
      "& img": { width: "100%", height: "100%", objectFit: "contain", padding: 4 },
    },
    idCell: { width: 90 },
    actionsCell: { width: 110 },
  };
});

const QueueIntegration = () => {
  const classes = useStyles();
  const panel = usePanelStyles();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [queueIntegration, dispatch] = useReducer(reducer, []);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const { getPlanCompany } = usePlans();
  const companyId = user.companyId;
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useIntegrations) {
        toast.error(
          "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando."
        );
        setTimeout(() => {
          history.push(`/`);
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchIntegrations = async () => {
        try {
          const { data } = await api.get("/queueIntegration/", {
            params: { searchParam, pageNumber },
          });
          dispatch({
            type: "LOAD_INTEGRATIONS",
            payload: data.queueIntegrations,
          });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchIntegrations();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    const onQueueEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({
          type: "UPDATE_INTEGRATIONS",
          payload: data.queueIntegration,
        });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_INTEGRATION", payload: +data.integrationId });
      }
    };

    socket.on(`company-${companyId}-queueIntegration`, onQueueEvent);
    return () => {
      socket.off(`company-${companyId}-queueIntegration`, onQueueEvent);
    };
  }, []);

  const handleOpenUserModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(true);
  };

  const handleCloseIntegrationModal = () => {
    setSelectedIntegration(null);
    setUserModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditIntegration = (queueIntegration) => {
    setSelectedIntegration(queueIntegration);
    setUserModalOpen(true);
  };

  const handleDeleteIntegration = async (integrationId) => {
    try {
      await api.delete(`/queueIntegration/${integrationId}`);
      toast.success(i18n.t("queueIntegration.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingUser(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  return (
    <MainContainer maxWidth>
      <ConfirmationModal
        title={
          deletingUser &&
          `${i18n.t("queueIntegration.confirmationModal.deleteTitle")} ${
            deletingUser.name
          }?`
        }
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteIntegration(deletingUser.id)}
      >
        {i18n.t("queueIntegration.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <IntegrationModal
        open={userModalOpen}
        onClose={handleCloseIntegrationModal}
        aria-labelledby="form-dialog-title"
        integrationId={selectedIntegration && selectedIntegration.id}
      />
      {user.profile === "user" ? (
        <ForbiddenPage />
      ) : (
        <>
          <MainHeader>
            <Title>
              {i18n.t("queueIntegration.title")}
              <StatusBadge
                color="neutral"
                dot={false}
                label={`${queueIntegration.length}`}
              />
            </Title>
            <MainHeaderButtonsWrapper>
              <TextField
                placeholder={i18n.t("queueIntegration.searchPlaceholder")}
                type="search"
                value={searchParam}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" color="disabled" />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                size="small"
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenUserModal}
              >
                {i18n.t("queueIntegration.buttons.add")}
              </Button>
            </MainHeaderButtonsWrapper>
          </MainHeader>
          <Paper
            className={panel.tableCard}
            elevation={0}
            onScroll={handleScroll}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{i18n.t("queueIntegration.table.type")}</TableCell>
                  <TableCell>{i18n.t("queueIntegration.table.name")}</TableCell>
                  <TableCell align="right" className={classes.idCell}>
                    {i18n.t("queueIntegration.table.id")}
                  </TableCell>
                  <TableCell align="right" className={classes.actionsCell}>
                    {i18n.t("queueIntegration.table.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {queueIntegration.map((integration) => {
                    const logo = TYPE_LOGOS[integration.type];
                    const TypeIcon =
                      TYPE_ICONS[integration.type] || ExtensionOutlined;
                    return (
                      <TableRow key={integration.id}>
                        <TableCell>
                          <div className={classes.typeCell}>
                            {logo ? (
                              <span
                                className={`${classes.typeMark} ${classes.typeLogo}`}
                              >
                                <img src={logo} alt="" />
                              </span>
                            ) : (
                              <span className={classes.typeMark}>
                                <TypeIcon />
                              </span>
                            )}
                            <span className={panel.cellMuted}>
                              {typeLabel(integration.type)}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className={panel.cellStrong}>
                          {integration.name}
                        </TableCell>
                        <TableCell align="right" className={panel.cellMuted}>
                          {integration.id}
                        </TableCell>
                        <TableCell align="right">
                          <div className={panel.rowActions}>
                            <Tooltip title="Editar">
                              <IconButton
                                size="small"
                                aria-label={`Editar ${integration.name}`}
                                onClick={() => handleEditIntegration(integration)}
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Excluir">
                              <IconButton
                                size="small"
                                aria-label={`Excluir ${integration.name}`}
                                onClick={(e) => {
                                  setConfirmModalOpen(true);
                                  setDeletingUser(integration);
                                }}
                              >
                                <DeleteOutline />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {loading && <TableRowSkeleton columns={4} />}
                </>
              </TableBody>
            </Table>
            {!loading && queueIntegration.length === 0 && (
              <EmptyState
                icon={<ExtensionOutlined />}
                title={
                  searchParam
                    ? "Nenhuma integração encontrada"
                    : "Nenhuma integração cadastrada"
                }
                message={
                  searchParam
                    ? "Tente outro termo de busca."
                    : "Conecte um ERP, um agente de IA ou um bot externo para usar nas filas e nos fluxos."
                }
                action={
                  !searchParam && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpenUserModal}
                    >
                      {i18n.t("queueIntegration.buttons.add")}
                    </Button>
                  )
                }
              />
            )}
          </Paper>
        </>
      )}
    </MainContainer>
  );
};

export default QueueIntegration;
